import ListingPage from '../../components/ListingPage';
import TextMessagesCards from '../../components/TextMessages/TextMessagesCards';

const TextMessagesPage = () => {
  return (
    <ListingPage
      createRestrictionKey="textMessagesCreate"
      entityType="textMessage"
      useStats={true}
      filterBy="name"
      Cards={TextMessagesCards}
    />
  );
};

export default TextMessagesPage;
